import packageJson from "../../../../package.json"

export default function SplashScreen() {
  return (
    <div id="splash-screen">
      <p id="app-version">v{packageJson.version}</p>
    </div>
  )
}
